// src/Backend/Firebase/FirebaseConfigData.js

// 🚀 Firebase SDK Imports
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

// 🔐 Securely access API key from environment (.env file)
const APP_FIREBASE = import.meta.env.VITE_FIREBASE;

// ✅ Firebase project configuration
const firebaseConfig = {
  apiKey: APP_FIREBASE, // Make sure .env contains VITE_FIREBASE=YOUR_API_KEY
  authDomain: "forumde-16307.firebaseapp.com",
  projectId: "forumde-16307",
  storageBucket: "forumde-16307.appspot.com", // 🔧 Fixed typo from "firebasestorage.app" to "appspot.com"
  messagingSenderId: "839676330554",
  appId: "1:839676330554:web:4bf892d92169d2b8e36b03",
  measurementId: "G-G8Y2NH1E4Z"

  
};

// 🔥 Initialize Firebase App
const app = initializeApp(firebaseConfig);

// 📁 Initialize Firestore (NoSQL Document DB)
const fireDB = getFirestore(app);

// 💾 Initialize Realtime Database (Optional, if needed)
const rtdb = getDatabase(app);

// 🔐 Initialize Auth (Optional, for login)
const auth = getAuth(app);

// ☁️ Initialize Storage (for PDFs, Images, etc.)
const storage = getStorage(app);

// 🌍 Export all Firebase services
export { fireDB, auth, storage, rtdb, app };
